<template>
  <div>
    <div class="agreement-section" :class="customClass">
      <div class="checkbox-icon" :class="{ 'active': value }" @click="handleAgree"></div>
      <div class="agreement-text">
        <p>
          <span class="normal-text" @click="handleAgree">我已阅读并同意</span>
          <span class="link-text" v-for="item in getItems" :key="item.value" @click="openAgreement(item)">《{{ item.label
          }}》</span>
        </p>
      </div>
    </div>
    <AgreementPopup v-model="isShowAgreement" :user="user" :title="title" :type="agreeType" @agree="handleAgreementAgree" />
  </div>
</template>

<script>
import { agreements } from "../api";
import AgreementPopup from "./AgreementPopup.vue";
export default {
  name: "AgreedProtocol",
  components: {
    AgreementPopup
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user:{
      type:Object,
      default: () => ({})
    },
    customClass: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => []  
    }
  },
  data() {
    return {
      agreeType: '',
      isShowAgreement: false,
      title: "",
      isFalg: false,
    };
  },
  computed: {
    getItems() {
      var vs = [];
      if (this.items.length > 0) {
        for (var i of this.items) {
          vs.push({ label: agreements[i], value: i })
        }
      }
      return vs;
    }
  },
  methods: {
    handleAgree() {
      if (this.isFalg) {
        this.isFalg = false;
        this.$emit("input", true);
      } else {
        this.$emit("input", !this.value);
      }

    },
    openAgreement(row) {
      this.isShowAgreement = true;
      this.agreeType = row.value;
      this.title = row.label;
    },
    handleAgreementAgree() {
      this.isFalg = true
      this.handleAgree(true);
    }
  },
};
</script>

<style lang="less" scoped>
.agreement-section {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 20px;
  padding: 0 12px;

  .checkbox-icon {
    width: 14px;
    height: 14px;
    margin-top: 4px;
    background-image: url("/images/icon-seleted.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    &.active {
      background-image: url("/images/icon-selete.png");
    }
  }

  .agreement-text {
    flex: 1;

    p {
      font-family: "PingFang_SC", sans-serif;
      font-weight: 500;
      font-size: 12px;
      line-height: 24px;
      margin: 0;

      .normal-text {
        color: rgba(0, 0, 0, 0.8);
      }

      .link-text {
        color: #1e7ca1;
      }
    }
  }
}
</style>